import { render, staticRenderFns } from "./NavigationSearchForm.vue?vue&type=template&id=47c4912c"
import script from "./NavigationSearchForm.vue?vue&type=script&lang=ts"
export * from "./NavigationSearchForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ElementButton: require('/codebuild/output/src1993466134/src/acredo-website/components/element/elementButton.vue').default})
